import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      navigate('/' + hash);
    }
  };
  return <footer className="bg-brand-navy pt-16 pb-8 relative overflow-hidden" data-id="element-466">
      <div className="absolute inset-0 bg-paw-pattern-white opacity-5 pointer-events-none" data-id="element-467"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-468">
        {/* Logo */}
        <div className="flex justify-center mb-10" data-id="element-469">
          <Link to="/" className="inline-block" data-id="element-470">
            <img src="https://cdn.magicpatterns.com/uploads/bK7kdGFBapG8Hf2121LKyb/Logo_latido_y_huella_en_blanco.png" alt="Latido & Huella" className="h-16 md:h-20 object-contain" data-id="element-471" />
          </Link>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-10" data-id="element-472">
          {[{
          name: 'Inicio',
          href: '#inicio'
        }, {
          name: 'El Movimiento',
          href: '#movimiento'
        }, {
          name: 'Orden del día',
          href: '#agenda'
        }, {
          name: 'Boletos',
          href: '#tiquetes'
        }, {
          name: 'Patrocinadores',
          href: '#patrocinadores'
        }, {
          name: 'Contacto',
          href: '#contacto'
        }].map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-white/60 hover:text-brand-cyan text-sm transition-colors cursor-pointer" data-id="element-473">
              {link.name}
            </a>)}
        </div>

        {/* Legal & Utility Links */}
        <div className="flex flex-wrap justify-center items-center mb-8 gap-[10px]" data-id="element-474">
          <Link to="/terminos" className="text-white/40 hover:text-brand-cyan text-xs transition-colors" data-id="element-475">
            Términos y Condiciones
          </Link>
          <span className="text-white/20 text-xs" data-id="element-476">•</span>
          <Link to="/terminos#datos" className="text-white/40 hover:text-brand-cyan text-xs transition-colors" data-id="element-477">
            Habeas Data
          </Link>
          <span className="text-white/20 text-xs" data-id="element-478">•</span>
          <a href="#contacto" onClick={e => handleNavClick(e, '#contacto')} className="text-white/40 hover:text-brand-cyan text-xs transition-colors cursor-pointer" data-id="element-479">
            Comentarios
          </a>
        </div>

        {/* Social Links */}
        <div className="flex justify-center gap-4 mb-10" data-id="element-480">
          <a href="https://www.instagram.com/latidoyhuella" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-brand-cyan rounded-full flex items-center justify-center transition-colors text-white" aria-label="Instagram" data-id="element-481">
            <Instagram className="w-5 h-5" data-id="element-482" />
          </a>
          <a href="https://www.facebook.com/latidoyhuella" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-brand-cyan rounded-full flex items-center justify-center transition-colors text-white" aria-label="Facebook" data-id="element-483">
            <Facebook className="w-5 h-5" data-id="element-484" />
          </a>
          <a href="https://www.tiktok.com/@latidoyhuella" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-brand-cyan rounded-full flex items-center justify-center transition-colors text-white" aria-label="TikTok" data-id="element-485">
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-486">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-487" />
            </svg>
          </a>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 mb-8" data-id="element-488"></div>

        {/* Partner Logos */}
        <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-4 mb-8" data-id="element-489">
          <div className="text-white/50 text-xs uppercase tracking-widest" data-id="element-490">
            Organizado por
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/7j64q3bMK28v58qa96dbdH/logo-Diverxo.svg" alt="Diverxo" className="h-8 object-contain cursor-pointer hover:opacity-80 transition-opacity" onClick={() => window.dispatchEvent(new CustomEvent('open-diverxo-modal'))} data-id="element-491" />
          <div className="hidden sm:block w-px h-6 bg-white/20" data-id="element-492"></div>
          <div className="text-white/50 text-xs uppercase tracking-widest" data-id="element-493">
            Apoya
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/maWeGnwtqNXFiBgbgZj1BW/logo_comfama-Photoroom.png" alt="COMFAMA" className="h-8 object-contain" data-id="element-494" />
          <div className="hidden sm:block w-px h-6 bg-white/20" data-id="element-495"></div>
          <div className="text-white/50 text-xs uppercase tracking-widest" data-id="element-496">
            Powered by
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/1GiADDKPiox3HxhhQyuJik/Logo_Novo3d_trans.png" alt="NOVOeia" className="h-8 object-contain cursor-pointer hover:opacity-80 transition-opacity" onClick={() => window.dispatchEvent(new CustomEvent('open-novoeia-modal'))} data-id="element-497" />
        </div>

        {/* Closing Phrase */}
        <div className="text-center mb-8" data-id="element-498"></div>

        {/* Copyright */}
        <div className="text-center" data-id="element-499">
          <p className="text-white/40 text-xs" data-id="element-500">
            &copy; {new Date().getFullYear()} Latido & Huella — Diverxo Eventos
            Corporativos. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}